import * as React from "react";

import type { InputProps } from "./input";

interface InputColorProps extends InputProps {}

const InputColor = React.forwardRef<HTMLInputElement, InputColorProps>(({ ...props }, ref) => {
	return (
		<input
			type="color"
			className="h-[38px] w-[38px] cursor-pointer appearance-none rounded-md border border-zinc-300 bg-white pt-[0.5px] hover:bg-zinc-100"
			ref={ref}
			{...props}
		/>
	);
});

InputColor.displayName = "InputColor";

export { InputColor };
